import 'bootstrap-table/src/bootstrap-table.js'
import 'bootstrap-table/src/locale/bootstrap-table-es-ES.js'
import 'bootstrap-table/src/extensions/cookie/bootstrap-table-cookie.js'
import 'bootstrap-table/dist/bootstrap-table.min.css'
import activaConversorHora from 'app/conversor-hora'
activaConversorHora();

